import axios from 'axios';
import i18n from '@/lang';
import { message } from 'ant-design-vue';
import { getParameterByName } from '@/utils/tools';

const ErrorMsg = {
  400: i18n.t('common.error.400'),
  401: i18n.t('common.error.401'),
  403: i18n.t('common.error.403'),
  404: i18n.t('common.error.404'),
  405: i18n.t('common.error.405'),
  408: i18n.t('common.error.408'),
  500: i18n.t('common.error.500'),
  501: i18n.t('common.error.501'),
  502: i18n.t('common.error.502'),
  503: i18n.t('common.error.503'),
  504: i18n.t('common.error.504'),
  505: i18n.t('common.error.505')
};

// 创建一个 axios 实例
const httpFetch = axios.create({
  timeout: 30 * 1000 // 请求超时时间
});

// 请求拦截器
httpFetch.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    // 发送失败
    return Promise.reject(error);
  }
);

// 响应拦截器
httpFetch.interceptors.response.use(
  response => {
    if (response && response.data.code < -1) {
      message.error(i18n.t('common.error.400'));
    }

    return response;
  },
  error => {
    const msg = error.response && error.response.status ? ErrorMsg[error.response.status] : i18n.t('common.error.400');
    return Promise.resolve({ code: -1, msg: msg });
  }
);

function requestOpen(data) {
  try {
    if (!data) {
      message.error('请填写完整的请求参数');
      return;
    }

    if (data && !data.api) {
      message.error('请填写请求api地址');
      return;
    }

    if (!data['query']) {
      data['query'] = {};
    }

    const queryLang = getParameterByName('lang');

    data['query']['lang'] = queryLang || window.localStorage.getItem('lang') || 'cn';

    return new Promise((resolve, reject) => {
      httpFetch({
        method: data.method,
        url: data.api,
        params: data.query,
        data: data.params
      })
        .then(response => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            reject({ msg: i18n.t('common.noReturn') });
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  } catch (err) {
    console.error(err);
  }
}

export { requestOpen };
